var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteLogoMarun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3944,
    height: 1334,
    viewBox: "0 0 3944 1334",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2549.45 127.36C2512.79 336.935 2230.91 431.525 1867.98 473.43C1164.51 554.71 156.265 437.953 35.9082 577.788C156.316 411.889 582.762 378.739 1052.89 364.568H1054.95C1688.72 345.185 2401.17 359.609 2549.4 127.309L2549.45 127.36Z",
    fill: "url(#paint0_linear_1080_1836)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3940.06 330.974C3326.63 486.369 2794.11 16.7751 1872.66 93.3698C1641.18 112.619 904.222 368.87 904.222 368.87C1085.25 258.339 1720.33 48.7063 1869.45 30.7606C2003.48 14.6196 2521.97 -63.5792 3139.12 116.328H3139.42C3192.9 132.018 3247.07 149.462 3301.85 169.213C3698.07 311.575 3940.06 330.974 3940.06 330.974Z",
    fill: "url(#paint1_linear_1080_1836)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3940.06 333.013C3699.84 601.771 3120.03 494.318 2630.92 475.437C2478.49 469.46 2334.96 472 2213.22 497.257C2654.07 294.406 3131.38 357.075 3482.83 384.075H3482.98C3690.3 399.916 3853.77 403.603 3940.06 332.964V333.013Z",
    fill: "url(#paint2_linear_1080_1836)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M437.421 569.76C398.054 678.911 260.19 679.063 148.221 676.932C79.49 675.663 20.413 673.532 0 695.301C26.9995 590.463 190.756 563.62 312.078 561.59C370.149 560.626 418.517 565.345 437.421 569.811V569.76Z",
    fill: "url(#paint3_linear_1080_1836)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2549.45 127.36C2512.78 336.302 2230.77 430.605 1867.69 472.384C1582.22 485.704 1473.72 353.659 1054.38 363.901C1688.42 344.526 2401.16 358.906 2549.45 127.309V127.36Z",
    fill: "url(#paint4_linear_1080_1836)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3140.29 116.344C2750.41 55.481 2411.06 1.63681 1873.15 93.3324C1641.55 112.584 904.222 368.87 904.222 368.87C1085.39 258.374 1720.79 48.7129 1869.98 30.7648C2004.08 14.6216 2522.84 -63.5879 3140.29 116.344Z",
    fill: "url(#paint5_linear_1080_1836)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3483.05 383.192C3190.66 377.92 3104.61 482.749 2630.99 474.246V474.395C2478.54 468.427 2334.98 470.963 2213.22 496.176C2654.14 293.68 3131.54 356.239 3483.05 383.192Z",
    fill: "url(#paint6_linear_1080_1836)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3577.71 562.118C3828.5 531.388 3935.48 424.364 3935.48 424.364C3966.25 551.757 3918.17 653.903 3577.71 562.118Z",
    fill: "url(#paint7_linear_1080_1836)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3382.59 1324.74L3715.81 762.962H3844.92L3940 1324.74H3822.24L3796.94 1189.53H3590.2L3509.95 1324.74H3382.59ZM3627.71 1098.8H3799.56L3761.17 872.874L3627.71 1098.8Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2900.85 1324.74L3019.48 762.962H3289.03C3348.35 762.962 3390.8 780.118 3416.39 814.429C3442.56 848.158 3449.25 893.81 3436.45 951.383C3428.89 989.183 3412.61 1022.04 3387.6 1049.95C3363.18 1077.87 3331.19 1097.35 3291.65 1108.4C3299.21 1115.96 3304.73 1124.1 3308.22 1132.83C3312.29 1141.55 3315.78 1153.18 3318.69 1167.72L3353.58 1324.74H3231.46L3196.56 1173.82C3193.66 1161.03 3189.29 1152.02 3183.48 1146.78C3177.66 1141.55 3166.61 1138.93 3150.33 1138.93H3057.87L3018.61 1324.74H2900.85ZM3078.8 1041.23H3200.05C3230.88 1041.23 3256.46 1034.54 3276.82 1021.17C3297.17 1007.21 3310.55 983.949 3316.94 951.383C3323.92 919.979 3322.47 897.008 3312.58 882.47C3303.28 867.931 3280.89 860.662 3245.41 860.662H3117.18L3078.8 1041.23Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2543.03 1333.46C2456.96 1333.46 2395.03 1309.91 2357.22 1262.8C2319.42 1215.11 2310.7 1143 2331.06 1046.47C2353.15 943.532 2390.66 869.094 2443.58 823.152C2497.09 777.21 2571.52 754.239 2666.9 754.239C2755.29 754.239 2817.81 777.21 2854.45 823.152C2891.67 869.094 2899.23 943.532 2877.13 1046.47C2856.77 1143 2819.84 1215.11 2766.34 1262.8C2712.84 1309.91 2638.4 1333.46 2543.03 1333.46ZM2564.84 1233.14C2617.76 1233.14 2659.63 1218.02 2690.45 1187.78C2721.27 1156.96 2743.66 1109.85 2757.62 1046.47C2768.09 998.198 2771.58 960.106 2768.09 932.192C2765.18 904.278 2753.84 884.505 2734.07 872.874C2714.29 860.662 2684.64 854.556 2645.09 854.556C2592.17 854.556 2550.01 869.094 2518.6 898.172C2487.78 926.667 2465.1 976.099 2450.56 1046.47C2437.19 1112.18 2438.35 1159.87 2454.05 1189.53C2470.34 1218.6 2507.26 1233.14 2564.84 1233.14Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1709.07 1324.74L1827.71 762.962H1945.47L1895.75 998.488H2140.87L2190.59 762.962H2308.36L2189.72 1324.74H2071.96L2121.68 1089.21H1876.56L1826.84 1324.74H1709.07Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1187.73 1324.74L1306.36 762.962H1562.82C1605.86 762.962 1640.17 771.976 1665.76 790.004C1691.93 807.45 1709.67 831.003 1718.97 860.662C1728.27 889.739 1729.15 921.724 1721.59 956.617C1709.37 1013.61 1684.37 1059.84 1646.57 1095.32C1609.35 1130.79 1557.01 1148.53 1489.55 1148.53H1342.13L1305.49 1324.74H1187.73ZM1362.19 1055.19H1479.95C1517.17 1055.19 1545.38 1046.47 1564.57 1029.02C1584.34 1010.99 1597.14 986.857 1602.95 956.617C1609.93 924.05 1608.48 899.334 1598.59 882.47C1589.29 865.023 1565.44 856.3 1527.06 856.3H1404.93L1362.19 1055.19Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M521.565 1324.74L640.201 762.962H754.475L847.813 1100.55L1084.21 762.962H1206.34L1087.7 1324.74H969.937L1047.57 959.234L859.153 1227.91H791.112L716.965 959.234L639.329 1324.74H521.565Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36 1324.74L154.635 762.962H557.647L538.456 854.555H253.207L222.676 998.488H475.649L456.458 1089.21H203.485L172.954 1234.01H458.202L439.011 1324.74H36Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1080_1836",
    x1: 40.4237,
    y1: 329.594,
    x2: 2545.13,
    y2: 374.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78F6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36B56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1080_1836",
    x1: 2131.36,
    y1: 260.592,
    x2: 3808.9,
    y2: 609.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D56555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1080_1836",
    x1: 2827.02,
    y1: 450.207,
    x2: 3903.53,
    y2: 389.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF775E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E3221"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1080_1836",
    x1: 213.006,
    y1: 577.857,
    x2: 224.998,
    y2: 689.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#686869"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1080_1836",
    x1: 1055.99,
    y1: 279.644,
    x2: 14.7903,
    y2: 260.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C85B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A84C40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1080_1836",
    x1: 907.934,
    y1: 171.431,
    x2: 3138.71,
    y2: 212.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB725A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB4E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1080_1836",
    x1: 2726.17,
    y1: 414.517,
    x2: 3416.14,
    y2: 559.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE755A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1624F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1080_1836",
    x1: 3576.65,
    y1: 516.917,
    x2: 3943.84,
    y2: 509.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B60A27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogoMarun);
export default __webpack_public_path__ + "static/media/white-logo-marun.8a4ea51df91ae89feeffcd86e95ddba6.svg";
export { ForwardRef as ReactComponent };